import { isSupported, getMessaging, getToken, onMessage } from 'firebase/messaging';
import { doc, updateDoc, arrayUnion, setDoc, getDoc } from 'firebase/firestore';
import { db } from './config';

// Initialize FCM for the current user. Requests permission, stores token in Firestore.
export async function initMessagingForUser(app, user, vapidKey) {
  try {
    const supported = await isSupported();
    if (!supported || !user) return null;

    const messaging = getMessaging(app);
    const token = await getToken(messaging, { vapidKey });
    if (!token) return null;

    const userRef = doc(db, 'users', user.uid);
    const snap = await getDoc(userRef);
    if (!snap.exists()) {
      await setDoc(userRef, { fcmTokens: [token] }, { merge: true });
    } else {
      await updateDoc(userRef, { fcmTokens: arrayUnion(token) });
    }
    return token;
  } catch (err) {
    // Permission denied or unsupported browser; fail silently to preserve disguise
    return null;
  }
}

// Foreground message listener (optional UI)
export function subscribeToForegroundMessages(app, handler) {
  return isSupported().then((supported) => {
    if (!supported) return () => {};
    const messaging = getMessaging(app);
    return onMessage(messaging, handler);
  });
}


